import {
  VuexModule,
  getModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import { NotifyHelper } from 'vue-kit'
import { Errors } from '@/dto/ErrorsResponse'
import Tax from '@/dto/taxes/Tax'
import TaxesService from '@/services/TaxesService'

@DynamicModule
class TaxStore extends VuexModule {
  public taxes: Tax[] = []
  public taxId: number | null = null
  public errors: Errors = {}

  get tax(): Tax | null {
    return this.taxes.find(tax => this.taxId === tax.id) || null
  }

  @Mutation
  public selectTax(taxId: number | null) {
    this.taxId = taxId
  }

  @Mutation
  public addTaxToList(model: Tax) {
    this.taxes.unshift(model)
  }

  @Mutation
  public removeTaxFromList(taxId: number) {
    this.taxes.splice(
      this.taxes.findIndex(tax => {
        return tax.id === taxId
      }),
      1
    )
  }

  @Mutation
  public updateTaxInList(model: Tax) {
    const index = this.taxes.findIndex(tax => tax.id === model.id)
    this.taxes.splice(index, 1, model)
  }

  @Mutation
  public setErrors(errors: Errors) {
    this.errors = errors
  }

  @Action({ rawError: true })
  async saveTax(model: Tax): Promise<any> {
    return TaxesService.saveTax(model)
      .then((tax: Tax) => {
        NotifyHelper.success('Таможенный сбор сохранен!')

        if (model.id) {
          this.updateTaxInList(tax)
        } else {
          this.addTaxToList(tax)
        }

        return tax
      })
      .catch(error => {
        if (!error.response.data.errors) {
          NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
        }

        this.setErrors(error.response.data.errors)
      })
  }

  @Action
  public removeTax(taxId: number) {
    return TaxesService.deleteTax(taxId)
      .then(() => {
        NotifyHelper.success('Сбор удален!')
        this.removeTaxFromList(taxId)
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера.')
      })
  }

  @MutationAction({ mutate: ['taxes'] })
  async loadTaxes() {
    const taxes = await TaxesService.loadTaxes()

    return { taxes }
  }
}

export default getModule(TaxStore)
